import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { WaitingMessage, ErrorMessage } from '../extras/toastMessages';
import clienteAxios from '../../config/axios';
import Swal from 'sweetalert2';
import { Badge } from 'react-bootstrap';
import { useParams, useHistory } from 'react-router';
//Función principal
const AudienceTodayList = () => {
    //Tomo los params
    const { date } = useParams();
    //Inicializo el hsitory
    const history = useHistory();
    //Si no hay fecha, redirecciono
    if(!date){
        history.push('/');
    }
    //Inicializo el state local
    const [ audiences, setAudiences ] = useState([]);
    useEffect(() => {
        loadAudiences();
    }, [date]);
    //Función que cargar audiencias
    const loadAudiences = async () => {
        try{
            //Cargo la espera
            WaitingMessage('Cargando información...');
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Seteo los parámetros
            //Hago la consulta
            const response = await clienteAxios.get(`/audiencia/dto?search=inicio:${date}&estado.id>3&sort=inicio:asc`);
            //Obtengo los datos
            const res = response.data;
            //const audiences = audiencesData;
            //Llamo al dispatch
            setAudiences(res.content)
            //Oculto espera
            Swal.close();
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Oculto espera
            Swal.close();
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
    //Renderizo
    return (
        <React.Fragment>
            <div id="wrapper">
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-1">
                                    <img src="/img/logo-oga.png" className="img-fluid" />
                                </div>
                                <div className="col-md-11">
                                    <h2>Audiencias del día</h2>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <table className="table table-sm table-hovered table-striped">
                                        <thead className="thead-light">
                                            <tr>
                                                <th className="align-middle text-center">
                                                    Legajo
                                                </th>
                                                <th className="align-middle text-center">
                                                    Carátula
                                                </th>
                                                <th className="align-middle text-center">
                                                    Estado
                                                </th>
                                                <th className="align-middle text-center">
                                                    Inicio
                                                </th>
                                                <th className="align-middle text-center">
                                                    Sala
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            audiences ? (
                                                audiences.map(audience => (
                                                    <tr key={`atd${ audience.id }`}>
                                                        <td className="align-middle text-center">
                                                            <small>
                                                            { audience.expediente.numero }
                                                            </small>
                                                        </td>
                                                        <td className="align-middle">
                                                            <small>
                                                            { audience.expediente.caratula }
                                                            </small>
                                                        </td>
                                                        <td className="align-middle text-center">
                                                            <Badge variant={audience.estado.css}>
                                                            { audience.estado.descripcion }
                                                            </Badge>
                                                        </td>
                                                        <td className="align-middle text-center">
                                                            <small>
                                                            { audience.inicio ? moment(audience.inicio).format('DD/MM/YYYY HH:mm') : '' }
                                                            </small>
                                                        </td>
                                                        <td className="align-middle text-center">
                                                            <small>
                                                            { audience.sala ? audience.sala.descripcion : '' }
                                                            </small>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : null
                                        }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <footer className="sticky-footer bg-white">
                        <div className="container my-auto">
                            <div className="copyright text-center my-auto">
                                <span>Oficina de Gestión de Audiencias - Poder Judicial de Tucumán</span>
                                <br/>
                                <small>&copy; 2020 - Dirección de Sistemas</small>
                            </div>
                        </div>
                    </footer>
                </div>
                
            </div>
        </React.Fragment>
    );
};

export default AudienceTodayList;